// ─── EXERCISE HISTORY ────────────────────────────────────────────────────────
export const RANGES=[{id:"1m",label:"1M"},{id:"3m",label:"3M"},{id:"6m",label:"6M"},{id:"all",label:"Tutto"}];

// ─── COACH AI ─────────────────────────────────────────────────────────────────
// ─── METODOLOGIE ─────────────────────────────────────────────────────────────
export const METODOLOGIE = {
  auto:    { label:"Automatico",          short:"Auto"    },
  rpe_asc: { label:"RPE Ascendente",     short:"RPE Asc" },
  failure: { label:"Straight to Failure", short:"Failure" },
  topset:  { label:"Top Set + Back-off", short:"Top Set" },
  rpt:     { label:"Reverse Pyramid",    short:"RPT"     },
};



// ─── MANUAL FORM ──────────────────────────────────────────────────────────────
export const EMPTY_SET={weight:"",reps:"",rpe:"",rir:""};
export const EMPTY_EX={name:"",type:"compound",sets:[{...EMPTY_SET},{...EMPTY_SET},{...EMPTY_SET}]};

// ─── IMPOSTAZIONI PAGE ───────────────────────────────────────────────────────
export const MET_DESC = {
  auto:    "Analizza automaticamente ogni serie: progressione, RPE, pattern di carico e ti suggerisce il prossimo step.",
  rpe_asc: "Ogni serie aumenta l'intensità (RPE). Ottimale per costruire la percezione dello sforzo e trovare il massimo della sessione.",
  failure: "Tutte le serie al cedimento muscolare. Massimo stimolo ipertrofico, richiede gestione attenta del recupero.",
  topset:  "Una serie massimale seguita da back-off sets al 80-85%. Bilanciamento tra intensità e volume.",
  rpt:     "Le serie pesano di più nella prima e decrescono. Permette prestazioni massimali con freschezza neuromuscolare.",
};

export const REP_RANGE_DEFAULT = { compound:{min:6,max:10}, isolation:{min:10,max:15} };

export const DEFAULT_SETTINGS = {
  metodologieAttive:{auto:true,rpe_asc:false,failure:false,topset:false,rpt:false},
  profilo:{eta:"",peso:"",altezza:"",sesso:"M",pesoTarget:"",livelloAttivita:"1.55",esperienza:"",obiettivo:"recomp"},
  intensita:"entrambi",   // "rpe" | "rir" | "entrambi"
  intensitaAttiva:true,   // false = nasconde RPE/RIR ovunque
  repRange:{ compound:{min:6,max:10}, isolation:{min:10,max:15} },
  deloadAuto:false,       // suggerisce deload preventivo ogni 5-6 settimane
  showInsights:false,     // mostra/nasconde i suggerimenti statici science.js nella UI
};
export let _globalSettings = (()=>{
  try{return{...DEFAULT_SETTINGS,...JSON.parse(localStorage.getItem("rc_settings")||"null")}||DEFAULT_SETTINGS;}
  catch{return DEFAULT_SETTINGS;}
})();
export function saveSettings(s){_globalSettings=s;localStorage.setItem("rc_settings",JSON.stringify(s));}

// ─── DASHBOARD WIDGETS ────────────────────────────────────────────────────────
export const WIDGET_DEFS = [
  { id:'settimana',    label:'Prossimo allenamento', desc:'Card con il prossimo allenamento suggerito', required:true },
  { id:'volume',       label:'Volume',              desc:'Grafico del volume nelle ultime settimane' },
  { id:'piano',        label:'Il tuo piano',        desc:'Analisi narrativa coach e progressioni', required:true },
  { id:'performance',  label:'Performance',         desc:'Stato degli esercizi: PR, progressione, stallo', hidden:true },
];
export const WIDGETS_VERSION = 3;
export const DEFAULT_WIDGETS = Object.fromEntries(WIDGET_DEFS.map(w=>[w.id,!w.hidden]));
